import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=22b58f56&scoped=true&"
import script from "./UserCreateForm.vue?vue&type=script&lang=js&"
export * from "./UserCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b58f56",
  null
  
)

export default component.exports